import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/sections/$sectionId/edit')({
  beforeLoad: () => {
    // TODO: Implement it - https://panowie.atlassian.net/browse/RG-249
    throw redirect({
      replace: true,
      to: '/'
    })
  }
})
